import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('COMMENTS_MODERATION').plugin(axiosPlugin, {template: "array"});

let fetchCommentsModerationAction = redux.fetchActionGet();

redux.reducerForType('DELETE', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState.data = newState.data.map(item => {
            item = {...item, countNotApprouved : item.countNotApprouved -1};
            return item;
        });
    }
    return newState;
});

redux.reducerForType('UPDATE', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState.data = newState.data.map(item => {
            item = {...item, countNotApprouved : item.countNotApprouved -1};
            return item;
        });
    }
    return newState;
});

export const fetchCommentsModeration = (type, query = {}) => fetchCommentsModerationAction(`/users/me/moderation-comments/${type}?${queryString.stringify(query)}`);
export const resetCommentsModeration = () => redux.actions.reset();

export const commentsModeration = redux.reducer();